import React from 'react';

// wraps any table cell value in bold HTML
export const boldColValueRenderer = (v: any) => {
  return (
    <span>
      <strong className="h-bold-column">{v}</strong>
    </span>
  );
};
